import React from 'react';
import { Box, Typography, Button } from '@mui/material';
// import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';

const playlistUrl = 'https://www.youtube.com/watch?v=hnPPM--73C8&list=PL1NYIfYLiXO2BBavx4scT4xAoptcCo40c&index=1';

const TutorialHeroCard = ({mobile = false}) => {
  const handleOpenTutorials = () => {
    window.open(playlistUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
    //   onClick={handleOpenTutorials}
      sx={{
        marginTop:'25px',
        flexDirection: mobile ? { xs: 'column', sm: 'row', md: 'row', lg: 'column' } : 'column',
        width: '100%',
        maxWidth: mobile ? '100%' : 420,
        minHeight: mobile ? 'auto' : 320,
        mx: 'auto',
        boxSizing: 'border-box',
        borderRadius: mobile ? '24px' : '28px',
        p: mobile ? 3 : { xs: 3, md: 4 },
        // cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        // flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'rgba(255,255,255,0.3)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        border: '1px solid rgba(255,255,255,0.45)',
        boxShadow: '0 12px 28px rgba(0,0,0,0.08)',
        transition: 'transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 26px 70px rgba(0,0,0,0.34)',
          borderColor: 'rgba(255,255,255,0.22)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -60,
          right: -40,
          width: 180,
          height: 180,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.08)',
          filter: 'blur(10px)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: -50,
          left: -30,
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: mobile ? 'none':'rgba(79, 172, 254, 0.14)',
          filter: 'blur(12px)',
        },
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 0.75,
            borderRadius: '999px',
            background: 'rgba(255,255,255,0.4)',
            mb: 2.5,
          }}
        >
          <MenuBookRoundedIcon sx={{ fontSize: 18, color: 'rgba(17, 24, 39, 0.8)' }} />
          <Typography
            sx={{
              color: 'rgba(17, 24, 39, 0.8)',
              fontSize: '0.85rem',
              fontWeight: 600,
              letterSpacing: '0.02em',
            }}
          >
            Need help getting started?
          </Typography>
        </Box>

        <Typography
          variant="h4"
          sx={{
            color: 'rgba(17, 24, 39, 0.8)',
            fontWeight: 800,
            lineHeight: 1.15,
            mb: 1.5,
            fontSize: { xs: '1.5rem', md: '1.8rem' },
          }}
        >
          How to use MediCheck
        </Typography>

        <Typography
          sx={{
            color: 'rgba(17, 24, 39, 0.82)',
            fontSize: '1rem',
            lineHeight: 1.7,
            maxWidth: 360,
          }}
        >
          Learn what MediCheck is, how to create an account, and how to use this system for your pharmacy.
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          mt: 4,
        }}
      >
        <Button
          onClick={handleOpenTutorials}
        //   startIcon={<PlayCircleFilledWhiteIcon />}
          endIcon={<ArrowOutwardRoundedIcon />}
          sx={{
            borderRadius: '999px',
            px: 3,
            py: 1.35,
            textTransform: 'none',
            fontSize: mobile ? '0.75' :'1rem',
            fontWeight: mobile ? 400 : 700,
            color: mobile ? '#fff': '#0f172a',
            background: mobile ? '#333':'#ffffff',
            boxShadow: 'none',
            '&:hover': {
              '&:hover': {
                background: '#333',
                color: '#fff',
                boxShadow: 'none',
            },
            },
          }}
        >
          Watch Tutorials
        </Button>
      </Box>
    </Box>
  );
}

export default TutorialHeroCard;